<template>
  <section
    id="section-projects"
    class="section-projects"
  >
    <div class="u-center-text u-margin-bottom-big">
      <h2 class="heading-secondary--accent">
        Check out Latest Machine Learning Projects
      </h2>
    </div>

    <div class="row">
      <div class="col-1-of-3">
        <div class="card">
          <div class="card__side card__side--front">
            <div class="card__picture card__picture--1">
                                     &nbsp;
            </div>
            <h4 class="card__heading">
              <span class="card__heading-span card__heading-span--1">Seq2Seq Tweet Generator</span>
            </h4>
            <div class="card__details">
              <ul>
                <li>Computer Vision</li>
                <li>Red blood cell classification</li>
                <li>Requires GPU</li>
                <li>Difficulty: hard</li>
              </ul>
            </div>
          </div>
          <div class="card__side card__side--back card__side--back-1">
            <div class="card__cta">
              <div class="card__price-box">
                <p class="card__price-only u-hidden-tab-port">
                  Seq2Seq
                </p>
                <p class="card__price-value u-hidden-tab-port">
                  Tweet Generator
                </p>
              </div>
              <a
                href="#popup"
                class="btn btn--white"
              >Check Blog Post!</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1-of-3">
        <div class="card">
          <div class="card__side card__side--front">
            <div class="card__picture card__picture--2">
                                     &nbsp;
            </div>
            <h4 class="card__heading">
              <span class="card__heading-span card__heading-span--1">NLP: Species determination</span>
            </h4>
            <div class="card__details">
              <ul>
                <li>Computer Vision</li>
                <li>Red blood cell classification</li>
                <li>Requires GPU</li>
                <li>Difficulty: hard</li>
              </ul>
            </div>
          </div>
          <div class="card__side card__side--back card__side--back-2">
            <div class="card__cta">
              <div class="card__price-box">
                <p class="card__price-only u-hidden-tab-port">
                  NLP: Species determination
                </p>
                <p class="card__price-value u-hidden-tab-port">
                  NLP
                </p>
              </div>
              <a
                href="#popup"
                class="btn btn--white"
              >Check Blog Post!</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1-of-3">
        <div class="card">
          <div class="card__side card__side--front">
            <div class="card__picture card__picture--3">
                                     &nbsp;
            </div>
            <h4 class="card__heading">
              <span class="card__heading-span card__heading-span--1">Darknet3: Feline RBCs</span>
            </h4>
            <div class="card__details">
              <ul>
                <li>Computer Vision</li>
                <li>Red blood cell classification</li>
                <li>Requires GPU</li>
                <li>Difficulty: hard</li>
              </ul>
            </div>
          </div>
          <div class="card__side card__side--back card__side--back-3">
            <div class="card__cta">
              <div class="card__price-box">
                <p class="card__price-only u-hidden-tab-port">
                  Darknet3:
                </p>
                <p class="card__price-value u-hidden-tab-port">
                  Feline RBCs
                </p>
              </div>
              <a
                href="#popup"
                class="btn btn--white"
              >Check Blog Post!</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="u-center-text u-margin-top-huge">
      <a
        href="#"
        class="btn btn--primary"
      >Discover all projects</a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Projects'
}
</script>
